<template>
    <div>
       <wx-open-launch-weapp
        id="launch-btn"
        appid='wx79077633383e7984'
        username="gh_e8f3836f799d"
        path="pages/index/index"
        env-version="trial"
        @launch="handleLaunchFn"
        @error="handleErrorFn"
      >
        <script type="text/wxtag-template">
  <style>
      .button {
        width: 275px;
        height: 43px;
        margin: 40px auto 0;
        background: linear-gradient(-1deg, #fda63d, #fbf4ca);
        box-shadow: 0px 2px 3px 0px rgba(158, 87, 0, 0.36);
        border-radius: 21px;
        border: none;
        line-height: 43px;
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: 500;
      }
  </style>
  <button class="button">进入小程序</button>
        </script>
      </wx-open-launch-weapp>
    </div>
</template>

<script>

import wx from 'jweixin-module'
export default {
    data() {
        return {
            wxHtml: ''
        }
    },
    methods: {
        handleLaunchFn(e) {
            console.log('success', e)
        },
        handleErrorFn(e) {
            console.log('fail', e.detail)
        },
        config() {
            let myUrl = window.location.href;
            this.httphelper.get("/api/CGpUserApi/GetWXShareConfigInfo", {
                url: myUrl
            }).then(data => {
                if (data.data) {
                    console.log(data.data)
                    wx.config({
                        debug: false,
                        appId: data.data.appid,
                        timestamp: data.data.timestamp,
                        nonceStr: data.data.nonceStr,
                        signature: data.data.signature,
                        jsApiList: ['openLocation'],
                        openTagList: ['wx-open-launch-weapp']
                    });
                    // this.getHtml()
                }
            })
        },
        getHtml() {
            let script = document.createElement('script')
            script.type = 'text/wxtag-template'
            script.text = `<button class="btn blue mt1" style="height: 50px;width: 100px;">跳转小程序</button>`
            this.wxHtml =
                `<wx-open-launch-weapp style="height: 50px;width: 100px;"
		                          id="launch-btn"
								    appid="wx79077633383e7984"
		                            username="gh_e8f3836f799d"
		                            path="pages/index/index"
		                          >${script.outerHTML}
		                        </wx-open-launch-weapp>`
            this.$nextTick(() => {
                let launchButton = document.getElementById('launch-btn')
                launchButton.addEventListener('launch', function (e) {
                    console.log('success', e)
                })

                launchButton.addEventListener('error', function (e) {
                    console.log('fail', e)
                })
            })
        }
    },
    mounted() {
        this.config()
    },

}
</script>